import React, { Component } from "react";
import { connect } from "react-redux";
import translate from "../TranslateHOC";
import Isvg from "react-inlinesvg";
import {
  fetchProfiles,
  setProfile,
  resetSetProfileSuccess,
  loginRedriect,
  setProfileChildFlag,
} from "../../actions";
import {
  PATH_PROFILE_EDIT,
  PATH_AUTHENTICATED_REDIRECT,
  PATH_PROFILES,
  localStorageIsChild,
} from "../../constants";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import add from "../../img/icons/add.svg";
import IsLoadingAnim from "../alerts/IsLoadingAnim";

class MyS4CProfiles extends Component {
  constructor(props) {
    super(props);
    //Set the active profile name when updated
    //so can use it within toast message in componentWillReceiveProps
    this.state = {
      activeProfileName: "",
    };
  }

  componentDidMount = () => {
    this.props.resetSetProfileSuccess();

    /* Login Successfull 
    Check that the main profile account child flag is set properly
    As child flag is not available in signin fetch request need to get it from the profiles fetch requests
    */
    this.props.fetchProfiles();
    if(this.props.profilesData && this.props.profilesData.profiles && this.props.profilesData.profiles.length > 0) {
      for (var i = 0; i < this.props.profilesData.profiles.length; i++) {
        if(this.props.profileId === this.props.profilesData.profiles[i].id) {
          if(localStorage.getItem(localStorageIsChild) !== this.props.profilesData.profiles[i].is_child_profile) {
            this.props.setProfileChildFlag(this.props.profilesData.profiles[i].is_child_profile);
          }
        }
      }
    }

    window.scrollTo(0, 0);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    //If profile is selected successfully do a toast message and redriect
    if (!nextProps.profilesError && nextProps.profileSetSuccess === true) {
      toast.success(
        `${this.props.strings.profileSetSuccess} ${
          this.state.activeProfileName
        }`,
        {
          className: "data-hj-suppress",
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      //Work out the redirect from the a state passed over by history.push
      const loginRedirect =
        this.props.stateLoginRedirect &&
        this.props.stateLoginRedirect.length > 0
          ? this.props.stateLoginRedirect
          : PATH_AUTHENTICATED_REDIRECT;
      this.props.history.push(loginRedirect);
    }

    if (nextProps.profilesError) {
      const loginRedirect =
        this.props.stateLoginRedirect &&
        this.props.stateLoginRedirect.length > 0
          ? this.props.stateLoginRedirect
          : PATH_AUTHENTICATED_REDIRECT;
      this.props.history.push(loginRedirect);
      this.props.loginRedriect();
    }
  };

  componentWillUnmount = () => {
    this.props.loginRedriect();
  };

  handleProfSelect(e, id, name) {
    e.preventDefault();
    //Set the active profile
    this.props.setProfile(id, true);
    this.setState({ activeProfileName: name });
  }

  handleKeyboardProfSelect = (event, id, name) => {
    event.preventDefault();
    if (event.charCode === 32 || event.charCode === 13) {
      this.handleProfSelect(event, id, name);
    }
  };

  render() {
    const profilesData = this.props.profilesData.profiles;
    const { strings, profilesError, profilesLoading, profileName } = this.props;

    let imgsrc = [];

    return (
        <div className="profiles main">
        <section className="my-s4c-content">
          <h2 className="section-title">{strings.whosWatching}</h2>

          {profilesError && (
            <div className="alert alert--error loading-error">
              {strings.sorryLoading}
            </div>
          )}

          {!profilesError && profilesLoading && <IsLoadingAnim />}

          {profilesData && Object.keys(profilesData).length && (
            <div className="profile-grid">
              {Object.keys(profilesData).map((key) => {
                imgsrc[key] = window.AVATAR_IMG_PATH + profilesData[key].avatar_filename;

                  let active = '';
                  if (profileName && profileName.length > 0) {
                    active =
                      profileName === profilesData[key].name
                        ? 'profile-grid__tile--active'
                        : '';
                  } else {
                    active =
                      profilesData[key].is_main_profile === 'Y'
                        ? 'profile-grid__tile--active'
                        : '';
                  }

                return (
                  <div className={"profile-grid__tile" + active} key={key}>
                    <div
                      className="profile-grid__avatar"
                      tabIndex={!active ? '0' : '-1'}
                      onClick={(e) =>
                        this.handleProfSelect(
                          e,
                          profilesData[key].id,
                          profilesData[key].name
                        )
                      }
                      onKeyPress={(e) =>
                        this.handleKeyboardProfSelect(
                          e,
                          profilesData[key].id,
                          profilesData[key].name
                        )
                      }
                    >
                      <div
                        className="profile-grid__avatar-image">
                        <img
                          className="profile-grid__avatar-img"
                          src={imgsrc[key]}
                          alt={profilesData[key].name}
                        />
                      </div>
                      </div>
                      <div className="profile-grid__actions">
                        <div className="profile-grid__name" data-hj-suppress>
                          {profilesData[key].name}
                        </div>
                        <Link
                          to={`${PATH_PROFILE_EDIT}/${profilesData[key].id}`}
                          className="profile-grid__edit"
                        >
                          <div className="ui button" data-hj-suppress>
                            {strings.edit}
                          </div>
                        </Link>
                        
                      </div>
                  </div>
                );
              })}
              <div className="profile-grid__tile profile-grid__tile--add">
                <Link to={`${PATH_PROFILE_EDIT}/add`}>
                  <Isvg className="profile-grid__add icon" src={add} />
                  <span className="profile-grid__label">
                    {strings.addProfile}
                  </span>
                </Link>
              </div>
            </div>
          )}
          <div className="my-s4c-content__footer-link">
            <Link to={`${PATH_PROFILES}`}>{strings.manageProfiles}</Link>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    curLang: state.curLang,
    profilesData: state.profilesData.success,
    profilesLoading: state.profilesData.loading,
    profilesError: state.profilesData.error,
    profileSetSuccess: state.profileSetSuccess,
    stateLoginRedirect: state.loginRedirect,
    profileName: state.profileName,
    profileId: state.profileId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProfiles: () => dispatch(fetchProfiles()),
    setProfile: (lang, id) => dispatch(setProfile(lang, id)),
    resetSetProfileSuccess: () => dispatch(resetSetProfileSuccess()),
    loginRedriect: (url) => dispatch(loginRedriect()),
    setProfileChildFlag: (flag) => dispatch(setProfileChildFlag(flag)),
  };
};

export default translate(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MyS4CProfiles)
);
